
import { computed, defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import Container from '@/components/form/container/Container.vue'
import SimpleTableForSingleSelect from '@/components/table/simple/SimpleTableForSingleSelect.vue'
import { updateReceiveBank } from '@/apis/paymentSlip/paymentSlip'
import { getByVendorNumber } from '@/apis/main-data/supplier'
import { SupplierBankModel } from '@/model/master-data/supplierModel'
import { SlipWorkUpdateReceiveBank } from '@/model/paymentSlip/paymentSlipModel'

export default defineComponent({
  name: 'PaymentSelectVendorBankDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    dataId: {
      type: Number,
      required: true
    },
    isSub: {
      type: Boolean,
      required: true
    },
    vendorNumber: {
      type: String,
      default: ''
    },
    vendorBankAccount: {
      type: String,
      default: ''
    },
    vendorBankCode: {
      type: String,
      default: ''
    },
    vendorBankName: {
      type: String,
      default: ''
    }
  },
  components: { SimpleTableForSingleSelect, Container },
  emits: ['update:modelValue', 'refresh'],
  setup(props, context) {
    const { t } = useI18n()
    const tableRef = ref()
    // 使用 computed 实现双向绑定
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: (value) => context.emit('update:modelValue', value)
    })
    const vendorBankTableStruct = [
      { prop: 'code', label: t('pay.bankCode') },
      { prop: 'name', label: t('pay.bankName') },
      { prop: 'account', label: t('pay.bankAccount') }
    ]
    const dataMap = reactive({
      tableData: Array<SupplierBankModel>(),
      listLoading: true,
      columnStruct: vendorBankTableStruct,
      defaultBankId: 0 as number | null,
      async getVendorBankList() {
        dataMap.listLoading = true
        const data = await getByVendorNumber(props.vendorNumber)
        if (data && data.data && data.data.length > 0) {
          dataMap.tableData = data.data
          const current = dataMap.tableData.find(d => d.account === props.vendorBankAccount)
          dataMap.defaultBankId = current ? current.id : data.data[0].id
          tableRef.value.setSelectedRow(dataMap.defaultBankId)
        } else {
          dataMap.tableData = []
        }
        tableRef.value.clearSelection()
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    const handleCancel = () => {
      dialogVisible.value = false
    }
    const handleConfirm = async() => {
      if (dataMap.tableData.length === 0 || tableRef.value.getSelectionRow() === null || tableRef.value.getSelectionRow() === undefined) {
        ElMessage({
          message: t('pay.bankEmptyAlertMessage'),
          type: 'error',
          duration: 2000
        })
        return
      }
      const param: SlipWorkUpdateReceiveBank = {
        isSubWork: props.isSub,
        workId: props.dataId,
        workSubId: props.dataId,
        vendorBankId: tableRef.value.getSelectionRow()
      }
      const res = await updateReceiveBank(param)
      if (res?.data && res?.data > 0) {
        ElMessage({
          message: t('common.setSuccess'),
          type: 'success',
          duration: 2000
        })
        context.emit('refresh')
        dialogVisible.value = false
      } else {
        ElMessage({
          message: res?.msg,
          type: 'error',
          duration: 2000
        })
      }
    }

    onMounted(() => {
      dataMap.getVendorBankList()
    })
    return {
      t,
      tableRef,
      dialogVisible,
      handleCancel,
      handleConfirm,
      ...toRefs(dataMap)
    }
  }
})
